var render, staticRenderFns
import script from "./filters-panel-filter-list.vue?vue&type=script&lang=js&"
export * from "./filters-panel-filter-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports